module.exports = __webpack_public_path__ + "img/icon-display-black.7981db1b.svg";